module.exports = __webpack_public_path__ + "img/半边莲.6cc624cd.jpg";